import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useShop } from "./ShopContext";

const LandingPage = () => {
  const navigate = useNavigate();
  const { setShop } = useShop();

  const goToShop = (selectedShop) => {
    setShop(selectedShop);
    navigate("/menu");
  };

  useEffect(() => {
    goToShop("platsak");
  }, []);

  return null;
};

export default LandingPage;